import { Component } from '@angular/core';

@Component({
    selector: 'app-cadastro-lawservices',
    templateUrl: './cadastro-lawservices.component.html',
    styleUrl: './cadastro-lawservices.component.css',
    standalone: false
})
export class CadastroLawservicesComponent {
  constructor() {
  }

}
